import { render } from "./ReceiveOrderTable.vue?vue&type=template&id=669b3170"
import script from "./ReceiveOrderTable.vue?vue&type=script&lang=js"
export * from "./ReceiveOrderTable.vue?vue&type=script&lang=js"

import "./ReceiveOrderTable.vue?vue&type=style&index=0&id=669b3170&lang=less"

import exportComponent from "/ssd/code/flow-business-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__